var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 1.40725C9.4975 1.3855 9.74725 1.375 10 1.375C14.7633 1.375 18.625 5.23675 18.625 10C18.625 10.2528 18.6145 10.5025 18.5928 10.75H17.4633C17.0868 14.5398 13.8888 17.5 10 17.5C5.85775 17.5 2.5 14.1423 2.5 10C2.5 6.11125 5.46025 2.91325 9.25 2.5375V1.4065V1.40725ZM9.25 10.75V4.0465C7.73703 4.23901 6.35414 5.0004 5.38239 6.17591C4.41064 7.35143 3.92296 8.85285 4.01847 10.375C4.11397 11.8972 4.7855 13.3259 5.89656 14.3707C7.00762 15.4155 8.47484 15.9981 10 16C11.4615 16 12.8727 15.4666 13.9688 14.5C15.0649 13.5334 15.7707 12.2 15.9535 10.75H9.25ZM17.086 9.25C16.9141 7.62843 16.1913 6.11485 15.0382 4.96179C13.8852 3.80874 12.3716 3.08594 10.75 2.914V9.25H17.086Z",
    fill: "#9A9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 1.40725C9.4975 1.3855 9.74725 1.375 10 1.375C14.7633 1.375 18.625 5.23675 18.625 10C18.625 10.2528 18.6145 10.5025 18.5928 10.75H17.4633C17.0868 14.5398 13.8888 17.5 10 17.5C5.85775 17.5 2.5 14.1423 2.5 10C2.5 6.11125 5.46025 2.91325 9.25 2.5375V1.4065V1.40725ZM9.25 10.75V4.0465C7.73703 4.23901 6.35414 5.0004 5.38239 6.17591C4.41064 7.35143 3.92296 8.85285 4.01847 10.375C4.11397 11.8972 4.7855 13.3259 5.89656 14.3707C7.00762 15.4155 8.47484 15.9981 10 16C11.4615 16 12.8727 15.4666 13.9688 14.5C15.0649 13.5334 15.7707 12.2 15.9535 10.75H9.25ZM17.086 9.25C16.9141 7.62843 16.1913 6.11485 15.0382 4.96179C13.8852 3.80874 12.3716 3.08594 10.75 2.914V9.25H17.086Z",
    fill: "url(#paint0_linear_784_4841)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_784_4841",
    x1: 10.5625,
    y1: 1.375,
    x2: 10.5625,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepIcon1);
export default __webpack_public_path__ + "static/media/dep_icon1.9716c5760a8260df78d0403d528bd323.svg";
export { ForwardRef as ReactComponent };